import React from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ isOpen, toggleSidebar, handleLogout }) => {
  const role = localStorage.getItem('role');
  const handleMenuClick = () => {
    toggleSidebar(); 
  };

  return (
    <>
      {isOpen && <div className="overlay" onClick={toggleSidebar}></div>}

      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="toggle-button" onClick={toggleSidebar}>
          {isOpen ? '✖' : '☰'}
        </div>
        {isOpen && (
          <>
            <h2>Dashboard</h2>
            <ul>
              <li><Link to="/Dashboard" onClick={handleMenuClick}>Daftar Kuisioner</Link></li>
              <li><Link to="/Summary" onClick={handleMenuClick}>Summary</Link></li>

              {role === 'admin' && (
                <>
                  <p><strong>Administrator</strong></p>
                  <li><Link to="/AddKategori" onClick={handleMenuClick}>Edit Kategori</Link></li>
                  <li><Link to="/AddKuisioner" onClick={handleMenuClick}>Edit Kuisioner</Link></li>
                  <li><Link to="/AddInformation" onClick={handleMenuClick}>Edit Information</Link></li>
                </>
              )}

              <li><Link to="/" onClick={() => { handleLogout(); handleMenuClick(); }}>Logout</Link></li>
            </ul>
          </>
        )}
      </div>
    </>
  );
};

export default Sidebar;